import { api } from "@api/api";
import { appendFormData } from "@core/utils/appendFormData";
import { FolderGenerationResult } from "@modules/folderGenerator/types";
import { FolderGeneratorFormValues } from "@modules/folderGenerator/validations";

export async function generateFolderService(
  data: FolderGeneratorFormValues
): Promise<FolderGenerationResult> {
  const payload = appendFormData({
    image: data.image,
    agreement_ids: data.agreement_ids,
  });

  const { data: result } = await api.post<FolderGenerationResult>(
    "v1/folder_generator/generate/",
    payload,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return result;
}
